'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonGroup = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _RadioButtonGroup = require('./RadioButtonGroup.style');

var _RadioButton = require('./RadioButton');

var _helpers = require('../helpers');

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var className = _ref.className,
      description = _ref.description,
      defaultSelected = _ref.defaultSelected,
      disabled = _ref.disabled,
      error = _ref.error,
      name = _ref.name,
      options = _ref.options,
      onComponent = _ref.onComponent,
      offComponent = _ref.offComponent,
      onSwitch = _ref.onSwitch,
      switched = _ref.switched,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['className', 'description', 'defaultSelected', 'disabled', 'error', 'name', 'options', 'onComponent', 'offComponent', 'onSwitch', 'switched']);
  return _react2.default.createElement(
    _FieldWrapper2.default,
    {
      description: description,
      error: error,
      labelFor: name },
    _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: className + ' ' + (disabled && 'disabled') }, rest),
      (0, _helpers.normalizeOptions)(options).map(function (option) {
        return _react2.default.createElement(_RadioButton.RadioButton, {
          disabled: disabled,
          onComponent: onComponent,
          offComponent: offComponent,
          option: option,
          onSwitch: onSwitch,
          switched: switched,
          key: _shortid2.default.generate() });
      })
    )
  );
};

exports.RadioButtonGroup = RadioButtonGroup;
RadioButtonGroup.propTypes = {
  /**
   * The children of the component, is generally and instance of the Step component
   */
  className: _propTypes2.default.string,
  /**
   * Description to be consumed by the wrapper, may render a tool tip
   */
  description: _propTypes2.default.string,
  /**
   * Optional, when provided with a valid option label, that option is selected by default
   */
  defaultSelected: _propTypes2.default.string,
  /**
   * Determines whether the entire radioButtonGroup is disabled
   */
  disabled: _propTypes2.default.bool,
  /**
   * Field label text to display above toggle
   */
  error: _propTypes2.default.string,
  name: _propTypes2.default.string,
  /**
   * Component to display when toggled "on"
   */
  onComponent: _propTypes2.default.node,
  /**
  * Component to display when toggled "off"
  */
  offComponent: _propTypes2.default.node,
  /**
   * Function to call when when switched.
   * Also fires onChange and onClick if passed as props.
   * Will not fire when disabled.
   */
  onSwitch: _propTypes2.default.func.isRequired,
  /**
  * List of RadioButtons to render.
  * Can take the form, ['listitem1', 'listitem2', 'listitem3'] if your labels and values
  * are the same.  Otherwise, it can take [{ label: 'listeitem1', value: 'someOtherValueName'} ...]
  */
  options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.any,
    value: _propTypes2.default.any
  }))]).isRequired,
  /**
   * Switched state from asSwtich HOC
   * @ignore
   */
  switched: _propTypes2.default.string
};

RadioButtonGroup.defaultProps = {
  onComponent: _react2.default.createElement('i', { className: 'fa fa-dot-circle-o' }),
  offComponent: _react2.default.createElement('i', { className: 'fa fa-circle-o' })
};

exports.default = (0, _helpers.asGroupSwitch)((0, _glamorous2.default)(RadioButtonGroup)(_RadioButtonGroup.defaultStyle, _RadioButtonGroup.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Radio/RadioButtonGroup.js
// module id = 543
// module chunks = 0